var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_vm._v(" Powered by "),_c('img',{staticClass:"logo_footer",attrs:{"alt":"Portaria-ja Logo","src":require("@/assets/images/favicon.png")}}),_vm._v(" PortariaJá! "+_vm._s(_vm.ano)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }